// Store Merger outcome for the retailer, sent per row by the API as `merge_status`:
// "historic" (a historical copy) or "duplicate" (merged into another retailer).
export const getMergeStatusSuffix = (mergeStatus) => (mergeStatus ? ` (${mergeStatus})` : '');

export const getRetailerNameLink = ({ retailerName, closeDate, isResidential, mergeStatus }) => {
  const notes = [mergeStatus, closeDate && `closed: ${closeDate}`, isResidential && 'residential location'].filter(
    Boolean,
  );

  if (!notes.length) return retailerName;
  return `${retailerName} (${notes.join(', ')})`;
};
